import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ArrowDown: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--arrowDown')}
    data-icon={icon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Arrow-Icon-Down-24x24"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fill="#747676" fillRule="nonzero">
        <g id="Arrow-Icon-Down-24x24">
          <path
            d="M12.0017235,9 L17.5034471,13.9515512 L16.5,15.0664924 L12.0017235,11.0180436 L7.5034471,15.0664924 L6.5,13.9515512 L12.0017235,9 Z"
            id="Arrow-Down-(SM)"
            transform="translate(12.001724, 12.033246) rotate(-180.000000) translate(-12.001724, -12.033246) "
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowDown;
